<template>
  <div class="multiselect-custom-field multiselect-tags">
    <multiselect
      :value="value"
      :customLabel="customLabelSingle"
      :track-by="valueKey"
      :placeholder="placeholder"
      open-direction="bottom"
      :options="optionsOrdered"
      :multiple="true"
      :searchable="true"
      :internal-search="true"
      :clear-on-select="true"
      :close-on-select="closeOnSelect"
      :taggable="false"
      :selectLabel="''"
      :selectedLabel="''"
      :deselectLabel="''"
      :disabled="disabled"
      @select="handleSelectedResult"
      @remove="handleRemove"
      @close="handleClose"
      @open="handleOpen"
      :class="classList"
    >
      <div
        class="caret"
        slot="caret"
        slot-scope="{ toggle }"
        @mousedown.prevent.stop="toggle"
      >
        <i
          class="Ctrl Ctrl--16"
          aria-hidden="true"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#dropdown-icon"></use>
          </svg>
        </i>
      </div>
      <template
        slot="selection"
        slot-scope="{values, isOpen}"
      >
        <span
          v-if="values.length > 0 && !isOpen"
          class="multiselect__custom-tag"
        >
          {{customLabel(values)}}
        </span>
        <span
          v-else
          class="multiselect__custom-tag"
        >
        </span>
      </template>
      <template slot="noResult">
        <span>{{$t('user_finder_selector_no_results')}}</span>
      </template>
      <template slot="noOptions">
        <span> {{$t('user_finder_selector_no_results')}}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  name: 'MultiSelectCustom',
  components: {
    Multiselect
  },
  props: {
    value: {},
    valueKey: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: ''
    },
    classList: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    label: {
      type: Array,
      default: () => []
    },
    translateLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    optionsOrdered () {
      let valuesId = this.value.map(item => item[this.valueKey])
      let optionsOrdered = []
      this.options.forEach(item => {
        if (valuesId.indexOf(item[this.valueKey]) !== -1) {
          optionsOrdered.unshift(item)
        } else {
          optionsOrdered.push(item)
        }
      })
      return optionsOrdered
    }
  },
  methods: {
    customLabelSingle (element) {
      let item = ''
      if (this.label.length > 0) {
        this.label.forEach(itemLabel => {
          if (this.translateLabel) {
            item += `${this.$t(element[itemLabel])} `
          } else {
            item += `${element[itemLabel]} `
          }
        })
      }
      return item
    },
    customLabel (values) {
      let items = ''
      values.forEach((item, index) => {
        if (this.label.length > 0) {
          this.label.forEach(itemLabel => {
            if (this.translateLabel) {
              items += `${this.$t(item[itemLabel])} `
            } else {
              items += `${item[itemLabel]} `
            }
          })
        }
        if (index + 1 < values.length) {
          items += ', '
        }
      })
      return items
    },
    handleSelectedResult (event) {
      this.$emit('setSelectedItems', event)
    },
    handleRemove (event) {
      this.$emit('removeItem', event)
    },
    handleClose (event) {
      this.$emit('close', event)
    },
    handleOpen (event) {
      this.$emit('open', event)
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect-custom-field.multiselect-tags {
  .multiselect__tags {
    display: flex;
    align-items: center;
    min-height: 44px !important;
  }
  .multiselect__custom-tag {
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: var(--text-body);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
